import { useEffect, useState } from 'react';
import { CONTACTS_PER_DAY } from '@shared/recruiting.js';
import { listenToDoc } from '@/utils/getDataFromDb';
import { UseCloudFunction, auth } from '@/utils/firebase.utils';

// The manager's own scouting/{teamId} document (college recruiting):
// scouting reports, replies and today's contacts. undefined while it
// loads, null when there's none yet or without a team (admins).
export function useScouting(leagueId, teamId) {
    const [ scouting, setScouting ] = useState(undefined);

    useEffect(() => {
        if (!teamId) { setScouting(null); return; }
        let unsub;
        let cancelled = false;
        // The security rules know a manager's team from the appId claim on
        // their sign-in token; tokens from before recruiting don't have it.
        (async () => {
            const token = await auth.currentUser?.getIdTokenResult();
            if (token && !token.claims.appId) {
                const res = await UseCloudFunction('signIn');
                if (res.claimsChanged) await auth.currentUser.getIdToken(true);
            }
            if (cancelled) return;
            listenToDoc({ 'path': `leagues/${leagueId}/scouting/${teamId}`, 'callback': setScouting, 'handleListener': (u) => { unsub = u; } });
        })();
        return () => { cancelled = true; if (unsub) unsub(); };
    }, [leagueId, teamId])

    return scouting;
}

// Contacts the manager has left on the league's current day. Contacts
// come back when the next game day is played.
export function contactsLeft(scouting, league) {
    const year = league.season.year ?? 1;
    const day = league.season.day ?? 0;
    const used = scouting?.year === year && scouting.contacts?.day === day ? scouting.contacts.used : 0;
    return Math.max(0, CONTACTS_PER_DAY - used);
}
